module.exports = __webpack_public_path__ + "img/geocerca.24b25b1d.svg";